
import { mapGetters } from 'vuex'
export default {
  props: {
    id: {
      default: 'modulecomp',
      type: String,
    },
    cpd: {
      type:String,
      default:'member',
    },
  },
  computed: {
    ...mapGetters({
      regionClicked : 'cart/getRegionClicked'
    }),
  },
}
